module.exports = __webpack_public_path__ + "img/vvv-colored.0c081895.png";